import API from "@/services/api";
import { 
  VirtualBatteryJoinTypes,
  ChangeVBPercentageAPIParams,
  ChangeVBTypeAPIParams,
  FetchVBTypesAPIResponse
} from "../types/virtualBattery";

export enum EndpointName {
  FetchTypes = '/contract/bateria/types',
  ChangeType = '/contract/:contractName/bateria/:bateriaId',
}

const fetchTypes = () => {
  return API.get<FetchVBTypesAPIResponse>({
    endpoint: EndpointName.FetchTypes,
    versions: [2]
  });
}

const changeType = (
  contractName: string, 
  bateriaId: number,
  selectedValue: VirtualBatteryJoinTypes
) => {
  return API.put<void, ChangeVBTypeAPIParams>({
    endpoint: EndpointName.ChangeType,
    versions: [2],
    data: { valor_descomptes: selectedValue },
    params: {
      contractName,
      bateriaId
    }
  });
}

export default {
  changeType,
  fetchTypes
};